import React, {useEffect, useMemo, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {
  dialogueAsyncActions,
  getTranslations,
  startXpedition
} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {Pages, TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import XpeditionIcon from 'assets/image/menu-auth/xpedition.png';
import {Link, useParams} from 'react-router-dom';
import {BotMode} from '@wholesalechange/chatcomponent';

import './styles.scss';
import {dialogueClearedAction} from '../../redux/dialogue/actions';

export const ActivityChat: React.FunctionComponent = () => {
  const {
    dialogue
  } = useSelector((state: IStore) => state.dialogue);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const {xpeditionId} = useParams();
  const shouldLoad = useRef(true);

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (xpeditionId) {
      if (shouldLoad.current) {
        shouldLoad.current = false;
        dispatch(dialogueClearedAction());
        dispatch(dialogueAsyncActions[startXpedition](Number(xpeditionId)));
      }
    }
  }, [xpeditionId]);

  const translationKey = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Activities.toLowerCase());

    return page?.translationKey || TranslationKeys.Activities;
  }, [settings]);

  useGetTranslations({translationKey});

  const title = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Activities.toLowerCase());

    return page?.title || Pages.Activities;
  }, [settings]);

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/activities">
        <FormattedMessage
          id={`gritx.common.navigation.${title}`}
          defaultMessage={title}
        />
      </Link> {dialogue && <span className="activity__title-dialogue-name"> - {dialogue.name}</span>}
    </div>;
  }

  return <div className="activity">
    {
      !loading.includes(getTranslations) && dialogue && <>
        <h1 className="activity__title">
          <img src={XpeditionIcon} alt="" className="activity__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat chatType={BotType.Xpedition} chatMode={BotMode.NoHistory} dialogueId={dialogue.id}
          title={dialogue.name}
          tabsEnabled={settings?.chatSettings?.tabsEnabled || false}/>
      </>
    }
  </div>;
};
